import { ASSETS } from '../config/assets'

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center space-x-4 mb-4 md:mb-0">
            <img 
              src={ASSETS.LOGO_COALBOT} 
              alt="Coalbot AI" 
              className="h-8 w-auto"
            />
            <div>
              <p className="text-sm font-medium">Powered by Coalbot AI</p>
              <p className="text-xs text-gray-400">Intelligent macroeconomic analysis</p>
            </div>
          </div>
          
          <div className="text-center md:text-right">
            <p className="text-sm text-gray-400">
              © 2025 The Core Briefing v2
            </p>
            <p className="text-xs text-gray-500 mt-1">
              Macroeconomic intelligence platform
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
} 